/**
 * Подготавливает паспорт для формы водителя и API без запросов и изменения оригинала.
 * Пустая форма создания имеет свои defaults; незагруженные вложения при редактировании сохраняются.
 */
// Возвращает независимые начальные значения для нового паспорта.
export function createEmptyDriverPassport() {
  return {
    series: "",
    number: "",
    issued_at: "",
    issued_by: "",
    issuer_code: "",
    last_name: "",
    first_name: "",
    middle_name: "",
    birth_date: "",
    birth_place: "",
    registration_address: "",
    gender: "",
    citizenship: "",
    attachment_ids: [],
    attachments: [],
  };
}

// Нормализует даты; null документа означает форму создания.
export function normalizeDriverPassportFormData(driverPassport = null) {
  if (driverPassport == null) return createEmptyDriverPassport();
  const normalizedDriverPassport = driverPassport || {};

  return {
    ...createEmptyDriverPassport(),
    ...normalizedDriverPassport,
    issued_at: dateValue(normalizedDriverPassport.issued_at),
    birth_date: dateValue(normalizedDriverPassport.birth_date),
    attachment_ids: attachmentIds(normalizedDriverPassport),
    attachments: Array.isArray(normalizedDriverPassport.attachments)
      ? normalizedDriverPassport.attachments
      : [],
  };
}

// Собирает заполненный паспорт, сохраняя null/отсутствие списка вложений.
export function buildDriverPassportPayload(formData = {}) {
  const driverPassport = formData.driver_passport || {};
  const payload = {
    series: stringOrNull(driverPassport.series),
    number: stringOrNull(driverPassport.number),
    issued_at: driverPassport.issued_at || null,
    issued_by: stringOrNull(driverPassport.issued_by),
    issuer_code: stringOrNull(driverPassport.issuer_code),
    last_name: stringOrNull(driverPassport.last_name),
    first_name: stringOrNull(driverPassport.first_name),
    middle_name: stringOrNull(driverPassport.middle_name),
    birth_date: driverPassport.birth_date || null,
    birth_place: stringOrNull(driverPassport.birth_place),
    registration_address: stringOrNull(driverPassport.registration_address),
    gender: stringOrNull(driverPassport.gender),
    citizenship: stringOrNull(driverPassport.citizenship),
    attachment_ids: attachmentIds(driverPassport),
  };

  const hasValues = Object.entries(payload).some(([key, value]) => {
    if (key === "attachment_ids") return (value?.length || 0) > 0;
    return Boolean(value);
  });

  // Существующий документ отправляем и после очистки последнего вложения.
  return driverPassport.id || hasValues ? payload : null;
}

// Возвращает подпись пола, неизвестное значение оставляет без преобразования.
export function formatDriverPassportGender(gender) {
  if (gender === "male") return "Мужской";
  if (gender === "female") return "Женский";

  return gender || "";
}

function attachmentIds(driverPassport = {}) {
  if (
    Object.prototype.hasOwnProperty.call(driverPassport, "attachment_ids") &&
    driverPassport.attachment_ids == null
  ) {
    return driverPassport.attachment_ids;
  }
  if (Array.isArray(driverPassport.attachment_ids)) {
    return [...driverPassport.attachment_ids];
  }

  if (Array.isArray(driverPassport.attachments)) {
    return driverPassport.attachments.map((attachment) => attachment.id).filter(Boolean);
  }

  return undefined;
}

function stringOrNull(value) {
  const normalized = String(value || "").trim();
  return normalized || null;
}

function dateValue(value) {
  if (!value) return "";

  return String(value).slice(0, 10);
}
